module.exports = __webpack_public_path__ + "img/arrow_front_icon.ee082cc3.svg";